import { useForm, useFormState } from "react-final-form";

import { CollapsibleCard, Stack } from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";
import { CheckboxGroupField } from "@ui-components/form/CheckboxGroupField.tsx";
import { FieldSpy } from "@ui-components/form/FieldSpy.tsx";
import { ToggleField } from "@ui-components/form/Toggle/ToggleField.tsx";

import {
  ClinicalFlagsFormValues,
  flagsNameOf
} from "./ClinicalFlagForm.types.ts";

export const YellowFlagsCard: React.FunctionComponent = () => {
  const form = useForm<ClinicalFlagsFormValues>();
  const { values } = useFormState<ClinicalFlagsFormValues>({
    subscription: { values: true }
  });

  const { clinical } = useStores();

  const yellowFlagOptions = clinical.ref.clinicalFlags.values
    .filter(x => x.isYellow)
    .map(({ code, clinicalFlagText }) => ({
      value: code,
      label: clinicalFlagText
    }));
  return (
    <div id="YellowFlags">
      <CollapsibleCard
        heading="Yellow flags"
        headingLevel="section-heading"
        iconName="BpRedFlagLine"
        openOnRender
      >
        <Stack tokens={{ childrenGap: 8 }}>
          <ToggleField
            name={flagsNameOf("yellowFlagsAllClear")}
            label="No abnormalities detected (NAD)"
            inlineLabel
            styles={{
              root: {
                margin: 0
              }
            }}
          />
          <CheckboxGroupField
            name={flagsNameOf("yellowFlags")}
            options={yellowFlagOptions}
            disabled={!!values.yellowFlagsAllClear}
          />
          <FieldSpy
            name={flagsNameOf("yellowFlagsAllClear")}
            onChange={(value: boolean) => {
              if (value) {
                if (form) {
                  form.change(flagsNameOf("yellowFlags"), undefined);
                }
              }
            }}
          />
        </Stack>
      </CollapsibleCard>
    </div>
  );
};
